import $ from 'jquery'
import {
  swatchGroupAttrs,
  swatchButtonHTML,
  staticSwatchHTML,
} from './card-a11y.js'

class FeaturedCollection extends HTMLElement {
  constructor() {
    super()
    let collections = JSON.parse(
      this.querySelector('.collection-data').textContent
    )
    this.buttonOverride = this.querySelector('.config').getAttribute(
      'enable_button_override'
    )
    this.collections = collections
    this.countryClubCustomer = this.getAttribute('countryClubUser')
  }
  connectedCallback() {
    this.renderProducts()
    this.mobileGridView()
    this.changeVariant()
  }

  changeVariant() {
    const self = this

    $(this).on('click', function (e) {
      if ($(e.target).hasClass('swatch') && !$(e.target).hasClass('active')) {
        let parent = $(e.target).closest('.product-grid-item')
        let handle = $(e.target).data('swatch')
        parent.addClass('parent-product')

        $(`.parent-product.${handle}`).eq(0).insertAfter(parent)
        $(`.parent-product.${handle}`).eq(0).removeClass('parent-product')
      }
      let selectedColorAmount =
        '(' +
        $('.filters-wrap input[type="checkbox"][data-type="Color"]:checked')
          .length +
        ')'
      let selectedSizeAmount =
        '(' +
        $('.filters-wrap input[type="checkbox"][data-type="Size"]:checked')
          .length +
        ')'
      let selectedFilterAmount =
        '(' + $('.filters-wrap input[type="checkbox"]:checked').length + ')'
      $('#sort-size').text('Shop by Size ' + selectedSizeAmount)
      $('.reset-filters').text('RESET ' + selectedFilterAmount)
      $('#sort-color').text('Shop by Color ' + selectedColorAmount)
    })
    $(document).off('click')
  }

  decodeId(id) {
    const shopifyId = id.split('/').pop()
    return parseInt(shopifyId)
  }

  renderProducts() {
    const self = this

    let products = self.collections[0].products

    let html

    if (!products.length) {
      return
    }

    let height = products.length > 4 ? 800 : 400
    $('.product-grid-item').removeClass('show')
    let buttonOverrideClass = this.buttonOverride == 'true' ? 'hidden' : 'flex'

    setTimeout(() => {
      this.querySelector('.items-grid').innerHTML = ''
      products.forEach((product, i) => {
        let selectedColor =
          product.options.filter(
            (option) => option.name.toLowerCase() == 'color'
          )[0]?.values[0].name || null
        let swatches = []
        let countryClubProduct = product.tags.includes('country-club-exclusive')
        let parentProducts = product.tags.filter((tag) =>
          tag.includes('Parent_')
        )
        if (parentProducts.length) {
          swatches.push({
            handle: product.handle,
            color: product.metafield.value,
          })
          parentProducts.forEach(function (tag) {
            let item = products.filter(
              (product) => product.handle == tag.split('Parent_')[1]
            )[0]
            swatches.push({
              handle: item.handle,
              color: item.metafield.value,
            })
          })
        }

        swatches = swatches.sort((a, b) => a.color.localeCompare(b.color))

        let button =
          this.buttonOverride == 'true'
            ? `<span class="flex pb-6"></span><a class="product-cta text-dark uppercase cursor-pointer font-bold flex hover:underline" href="${product.amazon_url}">${product.amazon_text}</a>`
            : `<span class="product-grid-item__cta-text product-cta text-dark uppercase cursor-pointer font-bold hover:underline" aria-label="Add to cart" aria-labelledby="Add to cart" tabindex="0" data-handle="${product.handle}" data-color="${selectedColor}" data-id="${product.variants[0].id}">add to cart</span>`

        if (countryClubProduct && this.countryClubCustomer == 'false') {
          button = `<a href="/pages/sell-your-soul" class=" ml-6 md:ml-0 product-grid-item__cta-text  text-dark uppercase cursor-pointer font-bold hover:underline">Country Club Exclusive</a>`
        }

        html = `
                    <div class="product-grid-item mb-6 ${product.handle} ${
          product.parentProduct ? 'parent-product' : ''
        }">
                        <div class="relative">
                          <a href="${product.url}" tabindex="0" class="block">
                            <img class="w-full aspect-1 object-cover" src="${
                              product.img
                            }" alt="${product.title}" />
                          </a>
                        </div>
                        <a href="${product.url}" tabindex="0" class="block">
                          <div class="text-dark product-grid-item__title mt-4">${
                            product.title
                          }</div>
                        </a>
                        <div class="text-dark product-grid-item__price mb-5">${
                          product.price
                        }</div>
                        
                        <div class="flex options-wrap items-center mt-3 mb-5 ${buttonOverrideClass} pb-4">`
        if (swatches.length || selectedColor) {
          html += `<div class="product-swatches ml-0 my-2" ${swatchGroupAttrs()}>`
          if (swatches.length) {
            swatches.forEach(function (swatch) {
              html += swatchButtonHTML({
                id: swatch.handle,
                active: swatch.handle == product.handle,
                colorClass: swatch.color
                  .toLowerCase()
                  .replaceAll(' ', '-')
                  .replaceAll('/', '-'),
                label: swatch.color,
              })
            })
          } else if (selectedColor) {
            let color = selectedColor
              .toLowerCase()
              .replaceAll(' ', '-')
              .replaceAll('/', '-')
            html += staticSwatchHTML(color, selectedColor)
          }

          html += `</div>`
        }

        html += `
          </div>
            ${button}
          </div>
        `

        if ($(window).width() < 1024) {
          if (i < 4) {
            this.querySelector('.items-grid').insertAdjacentHTML(
              'beforeend',
              html
            )
          }
        } else {
          this.querySelector('.items-grid').insertAdjacentHTML(
            'beforeend',
            html
          )
        }
      })
      setTimeout(() => {
        $('.product-grid-item').addClass('show')

        // a11y for label
        const labels = document.querySelectorAll('span.swatch')
        for (let label of labels) {
          label.addEventListener('keyup', (event) => {
            ;(event.code === 'NumpadEnter' ||
              event.code === 'Enter' ||
              event.code === 'Space') &&
              event.target.click()
          })
        }
      }, 100)
    }, 100)
  }

  mobileGridView() {
    this.querySelector('.grid-view-1')?.addEventListener('click', () => {
      this.querySelector('.grid-view-1').classList.add('hidden')
      this.querySelector('.grid-view-2').classList.remove('hidden')

      this.querySelector('#products-grid').classList.add('grid-cols-1')
      this.querySelector('#products-grid').classList.remove('grid-cols-2')
    })

    this.querySelector('.grid-view-2')?.addEventListener('click', () => {
      this.querySelector('.grid-view-2').classList.add('hidden')
      this.querySelector('.grid-view-1').classList.remove('hidden')

      this.querySelector('#products-grid').classList.add('grid-cols-2')
      this.querySelector('#products-grid').classList.remove('grid-cols-1')
    })
  }

  addToCart() {
    const self = this

    $(document).on('click', function (e) {
      if ($(e.target).hasClass('product-cta')) {
        let id = $(e.target).data('id')

        let formData = {
          items: [
            {
              id: id,
              quantity: 1,
            },
          ],
        }

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
          .then((response) => {
            window.location.href = '/cart'
          })
          .catch((error) => {
            console.error('Error:', error)
          })
      }
    })
  }
}
customElements.define('featured-collection', FeaturedCollection)
